<template lang="pug">
.dwgList
  .search
    van-search(right-icon='' v-model='keyWord' placeholder='请输入关键词检索' @search='searchKeyWord' @clear='clear')
    van-image(width='25' height='25' :src="require('./../../images/modelImage/list1.png')" v-if='isList1' @click='changeList(false)')
    van-image(width='25' height='25' :src="require('./../../images/modelImage/list2.png')" v-else @click='changeList(true)')
  .list1(v-if='isList1')
    .dwgInfo(v-for='(ele, index) in groupPics' :key='index' @click='showDwg(ele)')
      template(v-if="mlibEnabled")
        van-image(:src='ele.downloadUrl' alt='图纸缩略图')
        p(:title='ele.drawName') {{ele.drawName}}
      template(v-else)
        van-image(:src='ele.imgurl')
        p(:title='ele.picName') {{ decodeURIComponent(ele.picName) }}
  .list2(v-else)
    .dwgInfo(v-for='(ele, index) in groupPics' :key='index' @click='showDwg(ele)')
      van-image(width='30' height='30' :src="require('./../../images/modelImage/dwg.png')")
      template(v-if="mlibEnabled")
        p(:title='ele.drawName') {{ decodeURIComponent(ele.drawName) }}
      template(v-else)
        p(:title='ele.picName') {{ decodeURIComponent(ele.picName) }}
</template>

<script>
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  data () {
    return {
      options: [],
      keyWord: '',
      isList1: true,
      modelId: '',
      groupPics: []
    };
  },
  computed: {
    dwgALLlist() {
      return mongeApp.model.modelMapList;
    },
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    }
  },
  mounted () {
    this.groupPics = this.dwgALLlist;
  },
  methods: {
    searchKeyWord() {
      this.groupPics = this.dwgALLlist.filter(ele => decodeURIComponent(ele.picName).includes(this.keyWord));
    },
    clear() {
      this.groupPics = this.dwgALLlist;
    },
    async showDwg(ele) {
      if (this.mlibEnabled) {
        const { drawName, modelId } = ele;
        const models = await mongeApiMlib.getModels();
        mongeMutations.setModelPageFileName(decodeURIComponent(drawName));
        const list = models.find(e => e.id == modelId).url?.bimexDetailList;
        const url = list.filter(item => item.drawName == drawName && item.label == "2D");
        const bimexDetailList = [];
        url.forEach(e => {
          if (!e.drawName) return;
          const bimexItemFile = {
            originFileName: e.lightFileName,
            url: e.downloadUrl,
            fileId: e.fileId
          };
          bimexDetailList.push(bimexItemFile);
        });
        const spaceWithDetailItems = {
          bimexId: drawName,
          bimexName: drawName,
          convertFilePathId: drawName,
          bimexDetailList
        };
        const params = { url: spaceWithDetailItems, id: 'dwgbox', longforLoading: true, modelId };
        await mongeApiMlib.load2D(params);
      } else {
        const { picName, picsurl, modelFileId, rvtVersion } = ele;
        mongeMutations.setModelPageFileName(decodeURIComponent(picName));
        const params = {
          url: picsurl,
          id: 'dwgbox',
          longforLoading: true,
          modelFileId,
          rvtVersion
        };
        await mongeApiMlib.load2D(params);
      }
      mongeMutations.setModelMapData();
      await this.$nextTick();
      this.$emit("closeCom", 'modelDwgList', false);
    },
    changeList(boolean) {
      this.isList1 = boolean;
    }

  }
};
</script>

<style lang="scss" scoped>
.dwgList{
  position: fixed;
  top: 44px;
  width: 100%;
  height: calc(100% - 44px);
  background-color: #F5F6FA;
  z-index: 5;
  .search{
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fff;
    .van-search{
      width: calc(100% - 30px);
    }
    .van-image{
      width: 30px;
    }
  }
  .van-search__content{
    border: 1px solid #E5E8F1;
    border-radius: 8px;
    opacity: 0.7;
    background-color: #fff;
  }
  .list1{
    width: 100%;
    height: calc(100% - 70px);
    margin-top: 15px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .dwgInfo{
      width: 100%;
      height: 200px;
      padding: 0 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .van-image{
        width: 100%;
        height: 160px;
      }
      p{
        height: 40px;
        font-size: 17px;
        font-weight: 400;
      }
    }
  }
  .list2{
    width: 100%;
    height: calc(100% - 70px);
    margin-top: 15px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .dwgInfo{
      width: 100%;
      height: 70px;
      min-height: 70px;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      background-color: #fff;
      border-bottom: 1px solid #e8ebef;
      .van-image{
        margin-left: 10px;
        margin-right: 10px;
      }
      p{
        font-weight: 400;
        font-size: 16px;
      }
    }
  }
}
</style>
